import { owcTheme } from 'core/theme/theme.config';
import { PocTab } from 'commons/components/components-wrapper/poc-tab.component';
import { PocTabs } from 'commons/components/components-wrapper/poc-tabs.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { Img } from 'commons/components/image/img.component';
import styled from 'styled-components';

export const DevicesConfigurationDashboardHeaderStyled = styled.div`
    display: flex;
    flex-direction: column;
    padding-top: 32px;
    border-bottom: 1px solid ${owcTheme['one-color-gray-200']};
`;

export const DevicesConfigurationInfoHeaderStyled = styled.div`
    display: flex;
    gap: 24px;
    align-items: center;
    padding-left: 2rem;
    margin-bottom: 24px;
`;

export const DevicesConfigurationImage = styled(Img)`
    width: 72px;
    background-color: ${owcTheme['one-color-background-base']};
`;

export const DevicesConfigurationInfoSection = styled.div`
    display: flex;
    flex-direction: column;
    text-transform: capitalize;
`;

export const DevicesConfigurationInfoBodyText = styled(PocTypography)`
    color: ${owcTheme['one-color-interaction-default-intensity-medium']};
`;

export const DevicesConfigurationDashboardTab = styled(PocTab)`
    background-color: unset !important;
`;

export const DevicesConfigurationDashboardHeaderStyledPocTabs = styled(PocTabs)`
    padding-left: 2rem;
`;
